export const isDefined = (obj: any) => {
  return obj !== null && obj !== undefined;
};
